import React, { useEffect, useRef, useState, useContext } from "react";

import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { confirmDialog } from "primereact/confirmdialog";

import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import Card from "../../../../Base/Components/Card/Card";
import { toastShow } from "../../../../Base/Services/ToastService";

import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";
import { cambiarEstadoConstrucciones, getConstrucciones } from "../../../../API/Global/Construcciones/ConstruccionesRequest";

import ConstruccionesCRUD from "./ConstruccionesCRUD";
import SubconstruccionesCRUD from "./SubconstruccionesCRUD";


const ConstruccionesEnProcesoScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogSub, setShowDialogSub] = useState(false);
  const [estados, setEstados] = useState([]);


  const getInfo = async () => {
    setLoading(true);
    const estadosTempo = await getEstadosCategory('General')
    setEstados(estadosTempo.filter(i => i?.IdStatus !== 7))

    const construccionesTempo = await getConstrucciones()
    setData(construccionesTempo)

    setLoading(false);
  };

  const changeEstado = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            if (selected.length > 0) {
              changes = selected.map((item) => {
                return {
                  IdConstruccion: item.IdConstruccion,
                  IdStatus: e.value.IdStatus,
                  StatusName: e.value.StatusName,
                };
              });
            } else {
              changes.push({
                IdConstruccion: data.IdConstruccion,
                IdStatus: e.value.IdStatus,
                StatusName: e.value.StatusName,
              });
            }
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName} a ${changes.length}  ${changes.length > 1 ? 'Construcciones' : 'Construcción' } ?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdConstruccions = changes.map((item) => item.IdConstruccion);
                cambiarEstado(e.value.IdStatus, IdConstruccions.toString());
                getInfo();
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };
  
  const cambiarEstado = async (IdStatus, IdConstrucciones) => {
    const result = await cambiarEstadoConstrucciones({ IdStatus, IdConstrucciones });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
    setSelected([]);
  };

  const columns = [
    {
      field: "IdConstruccion",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdConstruccion){
            setSelected([data])
            setShowDialog(true)
        }
      },
    },
    {
      field: "NombreConstruccion",
      header: "Nombre",
      headerEn: "Name",
      className: "XXXXlarge",
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdConstruccion){
            setSelected([data])
            setShowDialog(true)
        }
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData.IdStatus,
        Estado: rowData.StatusName,
      }),
      editable: true,
      cellEditor: changeEstado,
    },
    {
      field: "Cuenta",
      header: "Cuenta",
      headerEn: "Account",
      className: "XXlarge",
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdConstruccion){
            setSelected([data])
            setShowDialog(true)
        }
      },
    },
    {
      field: "Comentario",
      header: "Comentario",
      headerEn: "Comment",
      className: "medium",
      flex:1,
      minWidth: 200,
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdConstruccion){
            setSelected([data])
            setShowDialog(true)
        }
      },
    },
    {
      field: "UserNameEdit",
      header: "Usuario Edit",
      headerEn: "User Edit",
      className: "medium",
    },
    {
      field: "UserNameCreate",
      header: "Usuario Creación",
      headerEn: "User Create",
      className: "medium",
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      Format: 'DateTime',
    },
    {
      field: "DateEditStr",
      header: "Fecha Edición",
      headerEn: "Date Edit",
      className: "medium",
      Format: 'DateTime',
    },
    {
      field: "IdConstruccion",
      header: "",
      Format: "Botones",
      filter: false,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdConstruccion){
                setSelected([rowData])
                setShowDialog(true)
            }
          },
          tooltipOptions: {position: "left"},
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: data,
    loading: loading,
    selected: selected,
    setSelected: setSelected,
    showModal: () => {}
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "construcciones", config.language));
    getInfo();
  }, []);

  return (
    <div className=" p-fluid px-4" style={{ width: "100%", height: "100%", margin: "auto" }} >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="d-flex gap-2">
            <h3>{getLabel(baseLang, "construcciones", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button icon="pi pi-plus" onClick={() => { setShowDialog(true); setSelected([]);}} />
            <Button label="Subconstrucciones" icon="pi pi-wrench" onClick={() => { setShowDialogSub(true);}} />
          </div>
        }
        contenido={
            <div style={{ height: '88vh', marginTop: 30 }}>
                <AgGrid table={table} />
            </div>
        }
      />

      {showDialog && (
        <ConstruccionesCRUD 
            showDialog={showDialog}
            setShowDialog={setShowDialog}
            selected={selected}
            setSelected={setSelected}
            getInfo={getInfo}
        />
      )}

      {showDialogSub && (
        <SubconstruccionesCRUD
            showDialog={showDialogSub}
            setShowDialog={setShowDialogSub}
        />
      )}
    </div>
  );
};

export default ConstruccionesEnProcesoScreen;
